const muiPagination = {
  styleOverrides: {
    ul: {
      justifyContent: 'center',
    },
  },
};

export default muiPagination;
